import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=25233ebd"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25233ebd')) {
      api.createRecord('25233ebd', component.options)
    } else {
      api.reload('25233ebd', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=25233ebd", function () {
      api.rerender('25233ebd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Users/Create.vue"
export default component.exports